import gql from 'graphql-tag';

import type { ApplicationsInput } from 'src/App/AppPageBlock/graphql/hirer-types.generated.ts';

import type {
  ApplicationsQueryVariables,
  ApplicationsQuery,
} from './fetchAllApplications.hirer.graphql.generated.ts';
import hirerGraphClient from './hirer/client';
import { findAuthenticationError } from './utils.ts';

// max number of applications supported by cm-search-api
// originally set by https://github.com/SEEK-Jobs/cm-search-api/pull/788
// note: never query verifications and questionnaireSubmission fields with this page size, otherwise it will cause 414 error in hirer-graph
const MAX_NUMBER_OF_SUPPORTED_APPLICATIONS = 5000;

const query = gql`
  query Applications($input: ApplicationsInput!) {
    applications(input: $input) {
      ... on ApplicationsResponseSuccess {
        result {
          id
          adcentreProspectId
          firstName
          lastName
          isRead
        }
      }
      ... on ResponseError {
        error
      }
    }
  }
`;

export const fetchAllApplications = async (
  input: Omit<ApplicationsInput, 'pagination'>,
) => {
  const result = await hirerGraphClient.query<
    ApplicationsQuery,
    ApplicationsQueryVariables
  >({
    variables: {
      input: {
        ...input,
        pagination: {
          pageSize: MAX_NUMBER_OF_SUPPORTED_APPLICATIONS,
        },
      },
    },
    query,
  });

  if (result.data === null && result.errors && result.errors.length > 0) {
    if (findAuthenticationError(result.errors)) {
      throw new Error('UNAUTHENTICATED');
    }
    throw new Error('Error fetching all applications');
  }

  if (result.data.applications.__typename === 'ResponseError') {
    throw new Error('Error fetching all applications');
  }

  return result.data.applications;
};
